var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.094,
    height: 40.094,
    viewBox: "0 0 40.094 40.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    d: "M0-682.665H40.094v40.094H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1173",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1175",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1177",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1183",
    transform: "translate(1.175 5.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1185",
    d: "M-488.091-548.776h-28.556a1.906,1.906,0,0,1-1.9-1.9v-30.441a1.906,1.906,0,0,1,1.9-1.9h2.176",
    transform: "translate(518.546 583.017)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1187",
    transform: "translate(5.25 0.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1189",
    d: "M-93.217-548.741h-3.92a1.9,1.9,0,0,1-1.9-1.9V-581.08a1.9,1.9,0,0,1,1.9-1.9h16.46l8.024,6.837v14.4m-4.707,13h-8.827",
    transform: "translate(99.033 582.98)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1191",
    transform: "translate(23.606 0.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1193",
    d: "M-128.591-109.57h-5.692a2.337,2.337,0,0,1-2.331-2.331v-4.506",
    transform: "translate(136.614 116.406)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1195",
    transform: "translate(10.061 11.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1197",
    d: "M0,0H16.755",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1199",
    transform: "translate(10.061 14.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1201",
    d: "M-181.029,0h5.459m-16.755,0h5.776",
    transform: "translate(192.325 0)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1203",
    transform: "translate(10.061 18.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1205",
    d: "M0,0H16.755",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1207",
    transform: "translate(10.061 22.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1209",
    d: "M-88.488,0h6.473M-94.009,0h1.577",
    transform: "translate(94.009)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1211",
    transform: "translate(10.061 26.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1213",
    d: "M0,0H9.645",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1215",
    transform: "translate(10.061 7.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1217",
    d: "M0,0H9.658",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1219",
    transform: "translate(24.337 22.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1221",
    d: "M-103.107-271.613a13.306,13.306,0,0,1-4.612-5.25,14.3,14.3,0,0,1-1.821-6.795c.009-.983.229-1.092,1.045-1.532l6.247-3.372L-96-285.189c.814.44,1.034.548,1.043,1.532a14.3,14.3,0,0,1-1.821,6.795,13.306,13.306,0,0,1-4.612,5.25A1.252,1.252,0,0,1-103.107-271.613Z",
    transform: "translate(109.541 288.561)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1223",
    transform: "translate(14.577 35.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    d: "M0,0H0",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1227",
    transform: "translate(29.189 28.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    d: "M0-30.31l1.588,1.489L4.88-32.2",
    transform: "translate(0 32.201)",
    fill: "none",
    stroke: "#36475a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulations);
export default __webpack_public_path__ + "static/media/regulations.212fd6121485ed9578bbab355684347e.svg";
export { ForwardRef as ReactComponent };